import {
  mapGetters,
  mapMutations
} from 'vuex';

const mixinSignInQuery = {
  computed: {
    ...mapGetters({
      storeQueryType: 'signInQuery/storeQueryType',
      storeSearchCondition: 'signInQuery/storeSearchCondition',
    }),
  },
  methods: {
    ...mapMutations({
      updateQueryType: 'signInQuery/updateQueryType',
      updateSearchCondition: 'signInQuery/updateSearchCondition',
      updateSignInQueryAll: 'signInQuery/updateSignInQueryAll'
    }),
  },
};

export {
  mixinSignInQuery
};



// WEBPACK FOOTER //
// ./src/components/signInManage/mixinSignInQuery.js